import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import InternetError from "../../components/Images/404error.png";
import ClipLoader from "react-spinners/ClipLoader";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import urlEnd from "../BaseUrl/endpointUrl";
const ErrorPage = () => {
  const color = "rgb(150, 143, 143)";
  const override = {
    display: " block",
    margin: "0 auto",
  };
  const [disabled, setdisabled] = useState(false);
  const navigate = useNavigate();

  return (
    <Grid container spacing={2} style={{ overflow: "hidden" }}>
      <Grid item xs={12} md={4} align="center"></Grid>
      <Grid item xs={12} md={4} mt={3} align="center">
        <Avatar
          src={InternetError}
          variant="square"
          style={{ width: "100%", height: "100%" }}
        ></Avatar>
      </Grid>
      <Grid item xs={12} md={4} align="center"></Grid>
      <Grid item xs={12} md={12} align="center">
        <Typography variant="h3" fontWeight={700}>
          404 Page Not Found
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} align="center"></Grid>
      <Grid item xs={12} md={6} align="center">
        <Typography variant="h6" fontWeight={500}>
          THE PAGE DOESN'T EXIST OR IS UNAVAILABLE.
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} align="center"></Grid>
      <Grid item xs={12} md={12} align="center">
        <Button
          disabled={disabled}
          startIcon={
            <ClipLoader
              color={color}
              loading={disabled}
              css={override}
              size={15}
            />
          }
          onClick={() => {
            setdisabled(true);
            setTimeout(() => {
              navigate(`${urlEnd}`);
            }, 10);
          }}
          className="btnSaveOnly"
        >
          Back To Home
        </Button>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
